import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom'
import * as Actions from './store/actions';
import * as NotificationActions from '../notification/store/actions/index';

import {
    Card, CardContent, Divider, IconButton, Button, Icon, Typography, Grid
} from '@material-ui/core';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import { Tooltip } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import AddIcon from '@material-ui/icons/Add';

import InstructorSelfPacedCourseDashboard from './widgets/InstructorSelfPacedCourseDashboard';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';

const localizer = BigCalendar.momentLocalizer(moment);

const styles = theme => ({
    root: {
        padding: '16px',
        '& .rbc-event-label': {
            display: 'none',
        },
        '& .rbc-row-segment': {
            padding: '0 4px 4px 4px'
        },
        '& .rbc-timeslot-group': {
            minHeight: '60px'
        },
        '& .cell': {
            padding: '0px',
            fontSize: '12px'
        },
        '& .assetblock': {
            display: 'inherit'
        }
    },
    popover: {
        pointerEvents: 'none',
    },
})

class InstructorCourseDashboard extends Component {

    constructor(props) {
        super(props);
        const ccc_id = this.props.match.params.company_calendar_course_id;
        const instructor_id = this.props.auth.user.data.role_info.link_id;
        const unscheduled = this.props.match.params.unscheduled;

        this.state = {
            ...this.state,
            ccc_id: ccc_id,
            instructor_id: instructor_id,
            unscheduled
        }
        this.props.getInstructorCourseData(ccc_id, instructor_id, unscheduled)
    }

    componentDidUpdate = (prevProps, prevState) => {
        const ccc_id = this.props.match.params.company_calendar_course_id;
        const unscheduled = this.props.match.params.unscheduled;
        if (
            !_.isEqual(ccc_id, prevProps.match.params.company_calendar_course_id)
        ) {
            this.props.updatePageLoaded(false)
            this.setState({
                ...this.state,
                ccc_id: ccc_id,
                unscheduled
            })
            this.props.getInstructorCourseData(ccc_id, this.state.instructor_id, unscheduled)
        }
    }

    handleEventSelect = (event) => {
        return this.props.history.push('/grade/student/list/' + event.company_calendar_event_id)
    }

    handleAddNotification = () => {
        this.props.setNotificationReference({
            NotificationReference: 'scheduled_course', 
            NotificationReferenceID: this.props.course.company_calendar_course_id,
            instructor_id: this.props.auth.user.data.role_info.link_id,
            NotificationType: 'scheduled_course'
        })
        this.props.history.push('/notification/create')
    }

    render() {
        const { course, theme, events, classes, Gradebook, EventsToGrade } = this.props;
        const getPopoverIcon = (event) => {
            const graded = event.StudentSubmissions.filter(e => e.IsGraded === 1).length;
            const waiting = event.StudentSubmissions.filter(e => e.IsGraded === 0).length
            let statusIcon
            if (moment(event.EndTime) > moment()) {
                return null
            }
            else if (graded === course.StudentCount) {
                statusIcon = <CheckIcon />
            }
            else if (waiting > 0) {
                statusIcon = <Icon>warning</Icon>
            }
            else {
                statusIcon = <Icon>access_time</Icon>
            }

            return (
                <div className='float-right'>
                    <Tooltip
                        title={
                            <React.Fragment>
                                <div>Outstanding: {course.StudentCount - event.StudentSubmissions.length}</div>
                                <div>To be Graded: {waiting}</div>
                                <div>Graded: {graded}</div>
                            </React.Fragment>
                        }
                        enterDelay={500}
                    >
                        <div className="flex items-center">
                            {/* {`${event.StudentSubmissions.length}/${course.StudentCount}`} */}
                            {statusIcon}
                        </div>
                    </Tooltip>
                </div>
            )

        }

        const customComponent = ({ event }) => (
            <div style={{ borderTop: 'white' }} key={event.id}>
                {
                    event.Unscheduled === 0 ?
                        <div className='float-left' style={{ paddingTop: '2px' }}>
                            <div style={{ fontSize: '10px' }}>
                                {moment(event.start).format('h:mm A')} - {moment(event.end).format('h:mm A')}
                            </div>
                            <div>
                                {event.title}
                            </div>
                        </div> :
                        <div className='float-left' style={{ paddingTop: '2px' }}>{event.title}</div>
                }

                {getPopoverIcon(event)}
            </div>
        )

        const eventStyleGetter = (event, start, end, isSelected) => {

            let borderString = '';
            if (event.Submitted) {
                borderString = '2px solid green'
            }
            else if (!event.Submitted && moment() > moment(event.start)) {
                borderString = '2px solid red'
            }

            let style = {
                backgroundColor: event.Color,
                color: this.props.theme.palette.getContrastText(event.Color),
                // border: borderString
            }

            return { style: style }
        }

        // console.log(this.props)
        return (
            <div className={classes.root}>
                <Grid container spacing={8}>
                    <Grid item xs={12}>
                        {this.props.match.params.unscheduled === '1' ?
                            <InstructorSelfPacedCourseDashboard events={events} StudentCount={course.StudentCount} history={this.props.history} />
                            :
                            <BigCalendar
                                components={{ event: customComponent }}
                                defaultView='work_week'
                                views={['work_week']}
                                localizer={localizer}
                                events={events}
                                toolbar={true}
                                step={60}
                                min={new Date(moment().startOf('day').add(6, 'hours'))}
                                max={new Date(moment().startOf('day').add(18, 'hours'))}
                                eventPropGetter={(eventStyleGetter)}
                                onSelectEvent={(e) => this.handleEventSelect(e)}
                                popup
                            />
                        }
                    </Grid>
                    <Grid item xs={6}>
                        <Card elevation={1} className="flex flex-col min-h-256">
                            <div
                                className="flex text-center h-64"
                                style={{
                                    background: course.Color,
                                    color: theme.palette.getContrastText(course.Color),
                                    display: 'block',
                                    fontSize: '20px',
                                    paddingTop: '10px'
                                }}
                            >   Assignments To Grade
                            </div>
                            <CardContent className=""
                                style={{ overflowY: 'scroll', maxHeight: '250px' }}
                            >
                                <Table style={{ margin: '0px', padding: '0xp' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='cell'>Student</TableCell>
                                            <TableCell className='cell'>Event Name</TableCell>
                                            <TableCell className='cell'>Submitted</TableCell>
                                            <TableCell className='cell'></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {EventsToGrade.map((e, i) => {
                                            return (
                                                    <TableRow key={i}>
                                                        <TableCell className='cell'>{e.StudentName}</TableCell>
                                                        <TableCell className='cell'>{e.EventName}</TableCell>
                                                        <TableCell className='cell'>{moment(e.Submitted).format('YYYY-MM-DD')}</TableCell>
                                                        <TableCell className='cell'>
                                                            <IconButton
                                                                onClick={() => this.props.history.push('/' + e.EventType.toLowerCase() + '/grader/' + e.grade_link_id)}
                                                                style={{ padding: '0px' }}
                                                            >
                                                                <Icon>edit</Icon>
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                    </TableBody>
                                </Table>
                            </CardContent>
                            <Divider />
                        </Card>
                    </Grid>
                    <Grid item xs={6}>
                        <Card elevation={1} className="flex flex-col min-h-256">
                            <div
                                className="flex text-center h-64"
                                style={{
                                    background: course.Color,
                                    color: theme.palette.getContrastText(course.Color),
                                    display: 'block',
                                    fontSize: '20px',
                                    paddingTop: '10px'
                                }}
                            >   Notifications
                                
                                <IconButton style={{ padding: '0px' }}
                                    onClick={() => this.handleAddNotification()}
                                >
                                    <AddIcon />
                                </IconButton>
                            </div>
                            <CardContent className=""
                                style={{ overflowY: 'scroll', maxHeight: '250px' }}
                            >
                                <Table style={{ margin: '0px', padding: '0xp' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='cell'>Instructor</TableCell>
                                            <TableCell className='cell'>Date</TableCell>
                                            <TableCell className='cell'>Title</TableCell>
                                            <TableCell className='cell'>Resolved</TableCell>
                                            <TableCell className='cell'></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>

                                        {course.Notifications
                                            .map(notification => {
                                                return (
                                                    <TableRow key={notification.notification_id}>
                                                        <TableCell className='cell'>{notification.InstructorEmail}</TableCell>
                                                        <TableCell className='cell'>{moment(notification.CreationDate).format('MM-DD-YYYY')}</TableCell>
                                                        <TableCell className='cell'>{notification.NotificationHeader}</TableCell>
                                                        <TableCell className='cell'>{notification.StudentList.filter(n => n.Resolved === 1).length}/{notification.StudentList.length}</TableCell>
                                                        <TableCell className='cell'>
                                                            <IconButton
                                                                onClick={() => this.props.history.push('/notification/edit/' + notification.notification_id)}
                                                                style={{ padding: '0px' }}
                                                            >
                                                                <Icon>edit</Icon>
                                                            </IconButton>
                                                        </TableCell>
                                                    </TableRow>
                                                )
                                            })}
                                    </TableBody>
                                </Table>
                            </CardContent>
                            <Divider />
                        </Card>
                    </Grid>
                    <Grid item xs={12}>
                        <Card elevation={1} justify="center" className="flex flex-col min-h-256">
                            <div
                                className="flex text-center h-64"
                                style={{
                                    background: course.Color,
                                    color: theme.palette.getContrastText(course.Color),
                                    display: 'block',
                                    fontSize: '20px',
                                    paddingTop: '10px'
                                }}
                            >
                                <div>Gradebook</div>
                            </div>
                            <CardContent className=""
                                style={{ overflowY: 'scroll', maxHeight: '250px' }}
                            >
                                <Table style={{ margin: '0px', padding: '0xp' }}>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className='cell'>Student</TableCell>
                                            <TableCell className='cell'>Submissions</TableCell>
                                            <TableCell className='cell'>Graded Submissions</TableCell>
                                            <TableCell className='cell'>Points</TableCell>
                                            <TableCell className='cell'>Average</TableCell>
                                            <TableCell className='cell'></TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {Gradebook.map(row => {

                                            return (
                                                <TableRow key={row.student_id}>
                                                    <TableCell className='cell'>{row.StudentName}</TableCell>
                                                    <TableCell className='cell'>{row.Submissions.length}/{course.Unscheduled === 0 ? course.EventsPassed : course.unscheduledTotalEvents}</TableCell>
                                                    <TableCell className='cell'>{row.Submissions.filter(s => s.IsGraded === 1).length}</TableCell>
                                                    <TableCell className='cell'>{row.FullStudentScore}/{row.FullCourseScore}</TableCell>
                                                    <TableCell className='cell'>{row.FullCourseAvg || 0}%</TableCell>
                                                    <TableCell className='cell'>
                                                        <IconButton
                                                            onClick={() => this.props.history.push('/gradebook/student/event_list/' + course.company_calendar_course_id + '/' + row.student_id)}
                                                        >
                                                            <Icon>search</Icon>
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })}
                                        <TableRow>
                                            <TableCell className='cell'><a href={'/gradebook/' + this.props.course.company_calendar_course_id}>See All</a></TableCell>
                                            <TableCell className='cell'></TableCell>
                                            <TableCell className='cell'></TableCell>
                                            <TableCell className='cell'></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </CardContent>
                            <Divider />
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getInstructorCourseData: Actions.getInstructorCourseData,
        setNotificationReference: NotificationActions.setNotificationReference,
        updatePageLoaded: Actions.updatePageLoaded
    }, dispatch);
}

function mapStateToProps({ auth, dashboardApp }) {
    return {
        auth,
        course: dashboardApp.instructorCourse.course,
        loaded: dashboardApp.instructorCourse.loaded,
        events: dashboardApp.instructorCourse.events,
        Gradebook: dashboardApp.instructorCourse.Gradebook,
        EventsToGrade: dashboardApp.instructorCourse.EventsToGrade
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(InstructorCourseDashboard)));


// WEBPACK FOOTER //
// src/main/content/dashboard/InstructorCourseDashboard.js